module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781618371621_0028_001",
      "id": "d7e809428",
      "src": "Images/9781618371621_0028_001.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/West_9781618371621_epub_c14_r1#d7e902332"
    }
  }, [_c('i', [_vm._v("Perfect Guacamole")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6582345a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c8_r1.vue
// module id = 90
// module chunks = 0